const prevImageButtonDesktop = setInterval(() => {
    if(document.querySelectorAll('.customily-modal-preview-only').length){
      clearInterval(prevImageButtonDesktop);
      const button = document.createElement('div');
      const container = document.createElement('div');
      container.style.background = '#ffffff';
      container.style.padding = '15px';
      container.style.width = '94vw';
      container.style.maxWidth = '600px';
      container.style.borderRadius = '20px';
      
      button.classList.add('button');
      button.classList.add('button--primary');
      button.classList.add('button--filled');
      button.classList.add('button--primary__filled');
      button.classList.add('ld-over-inverse');
      button.textContent = 'ADD TO CART';
      button.style.width = 'max-content';
      button.style.maxWidth = '100%';
      button.style.height = 'max-content';
      button.style.inset = '0';
      button.style.bottom = '0';
      
      button.style.margin = 'auto';
      button.style.fontSize = '1.5rem';
      if(window.innerWidth < 1150){
        button.style.marginTop = '10px';
      }else {
        button.style.marginTop = '10px';
      }
      button.addEventListener('click', function(){
        this.parentElement.parentElement.querySelector('.customily-close-button').click();
        document.getElementById('customily-cart-btn').click();
      });
      document.querySelector('.customily-modal-preview-only').style.padding = '10px 0';
      document.querySelector('.customily-modal-preview-only').style.justifyContent = 'center';
      document.querySelector('.customily-modal-preview-only').querySelector('.main').style.marginBottom = '10px';
      document.querySelector('.customily-modal-preview-only').querySelector('.main').appendChild(button);
      container.appendChild(document.querySelector('.customily-modal-preview-only').querySelector('.main'));
      document.querySelector('.customily-modal-preview-only').appendChild(container)
    }
  });
